var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("header-profil", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("main", { staticClass: "finishAdoptionScreen" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "finishAdoption__wrapper" }, [
          _c("div", { staticClass: "finishAdoption__msg" }, [
            _c("h2", { staticClass: "text-center" }, [
              _vm._v("\n                        Tvoja kravička "),
              _c(
                "span",
                { staticClass: "--colorOrange", attrs: { id: "cow-name" } },
                [_vm._v("Mutant")]
              ),
              _vm._v(" je rezervovaná a čaká kým doplníš ešte "),
              _c(
                "span",
                {
                  staticClass: "--colorOrange",
                  attrs: { id: "ean-count-left" }
                },
                [_vm._v("1 EAN kód")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "finishAdoption__countdown text-center mb-3" },
              [_vm._v("ZOSTÁVA 10 DNÍ")]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "text-center mb-3" }, [
              _vm._v(
                "Ak chceš mať kravičku adoptovanú je potrebné, aby si do 10 dní zadal aj ostatné kódy zo slovenských mliečnych výrobkov. Všetky výrobky nájdeš v "
              ),
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href:
                      "https://www.adoptujkravicku.sk/vyrobky-zapojene-do-projektu"
                  }
                },
                [_vm._v("zozname výrobkov")]
              ),
              _vm._v(".")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "finishAdoption__btns text-center" }, [
              _c(
                "a",
                {
                  staticClass: "btn --secondary mr-md-2 mb-2 mb-md-0",
                  attrs: { href: "" }
                },
                [_vm._v("Zoznam mojich kravičiek")]
              ),
              _vm._v(" "),
              _c("a", { staticClass: "btn --primary", attrs: { href: "" } }, [
                _vm._v("Doplniť ean kódy")
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }